if (window.innerWidth <= 719) {
    document.body.classList.add('smartphone');
}
window.onload = () => {
    if (/(tablet|ipad|playbook|silk)|(android(?!.*mobi))/i.test(window.navigator.userAgent)) {
        document.body.classList.add('tablet');
    }
    function attachSmartphone() {
        if (window.innerWidth <= 719) {
            document.body.classList.add('smartphone');
        }
        else {
            document.body.classList.remove('smartphone');
        }
    }
    window.addEventListener('resize', attachSmartphone);
};
export * from './utilities/drawer-utils';
export * from './utilities/popover-utils';
export * from './utilities/bottom-sheet-utils';
export * from './utilities/dialog-utils';
export * from './utilities/modal-utils';
export * from './utilities/toast-utils';
export * from './icons/icon-constants';
export * from './card-brands/card-brand-constants';
export * from './utilities/render-lottie-animation-utils';

//# sourceMappingURL=index.js.map
